// US-C11: permissões da clínica ativa nas telas da Clínica. Esconder a ação é
// só conveniência; quem bloqueia de verdade é a API (403).
export default {
  methods: {
    canEdit(area) {
      return this.clinicCan(area, "edit");
    },
    canView(area) {
      return this.clinicCan(area, "view");
    },
    clinicCan(area, level) {
      const can = this.$store && this.$store.getters["clinica/can"];
      return typeof can === "function" ? !!can(area, level) : true;
    }
  }
};
